module.exports = __webpack_public_path__ + "img/photo-55.6b82bad4.webp";